/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import TextLink from "@/components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "@/components/TextLink/types";
import { Typography } from "@mui/material";

import { colors } from "@dotnet/telematics-design-system";

const MiddleHowCreditsWorkDialogContent = () => {
  const { t } = useTranslation();

  return (
    <div
      css={css({
        gap: "8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start"
      })}
    >
      <Typography variant="body1Medium" color={colors.textDark}>
        {t("Dashboard##how credits work##middle content##header")}
      </Typography>

      <Typography variant="body2Regular" color={colors.textSecondary}>
        {t("Dashboard##how credits work##middle content##description")}
      </Typography>

      <TextLink
        size={TEXT_LINK_SIZES.Small}
        href="https://wiki.teltonika-gps.com/view/TachoSync_Credit_System" // placeholder link until MVS2 release
        target="_blank"
        rel="noreferrer"
        isIcon
      >
        {t("Dashboard##how credits work##middle content##read more on wiki")}
      </TextLink>
    </div>
  );
};

export default MiddleHowCreditsWorkDialogContent;
